/**
 * Common utility functions for Cash tile rates
 */

/**
 * Check if the price status is for ESP (electronic spot price)
 */
export const isEspStatus = (status: string) =>
  status === 'esp-required' || status === 'esp-pending' || status === 'esp-price';

/**
 * Check if the price status is for RFS (request for stream)
 */
export const isRfsStatus = (status: string) =>
  status === 'rfs-required' || status === 'rfs-pending' || status === 'rfs-price';
